var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0008 7.87476C17.5515 8.02589 17.9853 8.4712 18.1325 9.03671C18.4 10.0616 18.4 12.2001 18.4 12.2001C18.4 12.2001 18.4 14.3385 18.1325 15.3635C17.9853 15.929 17.5515 16.3743 17.0008 16.5255C16.0027 16.8001 12 16.8001 12 16.8001C12 16.8001 7.99728 16.8001 6.9991 16.5255C6.44834 16.3743 6.01459 15.929 5.86739 15.3635C5.59998 14.3385 5.59998 12.2001 5.59998 12.2001C5.59998 12.2001 5.59998 10.0616 5.86739 9.03671C6.01459 8.4712 6.44834 8.02589 6.9991 7.87476C7.99728 7.6001 12 7.6001 12 7.6001C12 7.6001 16.0027 7.6001 17.0008 7.87476ZM10.8 10.4001V14.4001L14 12.4001L10.8 10.4001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.da55eebb123e875fdd6485d10c62e92b.svg";
export { ForwardRef as ReactComponent };